import "./reset-password.component.scss"
import LOGO_MAIN from "../../assets/images/AIDA-power-by-logo.svg";
import LOGO from "../../assets/images/AIDA-logo.svg";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import COMPLETE_IMAGE from "../../assets/images/complete.png";
import { Button } from "react-bootstrap";
import { auth, db } from "../../firebase/auth.firebase";
import { confirmPasswordReset } from "firebase/auth";
import { resetpassword, sendInvite, updateUserStatus } from "../../services/api.service";
import BG from "../../assets/images/auth-bg.png";
import ResendLinkModal from "../../modal/resent-link/resend-link";
import { useSnackbar } from "../../utility/snackbar.utility";
import CustomSnackbar from "../snackbar/snackbar.component";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const ResetPasswordComponent = () => {
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isComplete, setIsComplete] = useState(false);
    const [errors, setErrors] = useState<{ confirmPassword?: string; password?: string }>({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isResendShow, setIsResendShow] = useState(false);
    const [email, setEmail] = useState("");
    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    useEffect(() => {
        if (searchParams.get("email")) {
            const email = decodeURIComponent(searchParams.get('email')+""); // Decode the email from the query params
            setEmail(email);
        }

    }, [email])
    // Validation function
    const validateForm = (): boolean => {
        const newErrors: { confirmPassword?: string; password?: string } = {};

        // Password validation
        if (!password) {
            newErrors.password = "กรุณากรอกรหัสผ่าน";
        } else if (password.length < 6) {
            newErrors.password = "กรุณาตั้งรหัสผ่านที่มีอย่างน้อย 6 ตัวอักษร";
        }
        // Password validation
        if (!confirmPassword) {
            newErrors.confirmPassword = "กรุณากรอกรหัสผ่าน";
        } else if (password.length < 6) {
            newErrors.confirmPassword = "กรุณาตั้งรหัสผ่านที่มีอย่างน้อย 6 ตัวอักษร";
        }
        if (confirmPassword != password) {
            newErrors.confirmPassword = "กรุณากรอกรหัสผ่านให้ตรงกัน";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            if (confirmPassword == password) {
                const oobCode = searchParams.get('oobCode'); // Get the oobCode from the query params

                if (!oobCode) {
                    //setMessage('Invalid or missing password reset code.');
                    return;
                }

                try {
                    // Complete the password reset
                    const result = await confirmPasswordReset(auth, oobCode, password);
                    setIsComplete(true);
                    //setMessage('Password has been reset successfully!');
                } catch (error: any) {
                    console.log(error);
                    // Handle specific error codes
                    if (error.code === "auth/invalid-action-code") {
                        console.log("Invalid or expired password reset code.");
                        setIsResendShow(true);
                    } else if (error.code === "auth/expired-action-code") {
                        console.log("Invalid or expired password reset code.");
                        setIsResendShow(true);
                    }

                    else if (error.code === "auth/weak-password") {
                        showSnackbar('รหัสของคุณเสี่ยงด้านความปลอดภัย กรุณาตั้งใหม่อีกครั้ง', error);
                    } else {
                        showSnackbar('เกิดข้อผิดพลาดกรุณาติดต่อ ผู้ดูแลระบบ', error);
                    }

                }

            }

            // Add further submit logic here (e.g., API call)
        }
    };
    const handleSubmitComplete = (e: React.FormEvent) => {
        e.preventDefault();
        navigate("/login")
    };

    const handleCloseResendShow = () => {
        setIsResendShow(false)
    }

    const onSubmitResendLink = async () => {
        try {

            const result = await resetpassword(email);
            showSnackbar('ส่งอีเมลตั้งค่ารหัสผ่านใหม่เรียบร้อย');
            setIsResendShow(false);
          
        } catch (error) {
            if (!auth.currentUser) return; // Ensure user is logged in before logging out
            const user = auth.currentUser;
            const logRef = collection(db, "logs");
            await addDoc(logRef, {
                timestamp: serverTimestamp(),
                user_id: user.uid,
                user_email: user.email,
                action_type: "LOGIN",
                error: error
            });
        }
    }
    return (
        <>
            <div className="reset-password-control">
                <div className="reset-password-left-control">
                    <img src={BG} className="image-auth-bg" />
                </div>

                <div className="reset-password-right-control">

                    {
                        isComplete ?

                            <>
                                <img src={LOGO} className="reset-password-logo-top-right"></img>
                                <div className="reset-password-right-content-control">
                                    <img src={COMPLETE_IMAGE} className="reset-password-complete-img"></img>
                                    <span className="reset-password-complete-title">ตั้งค่ารหัสผ่านใหม่สำเร็จกรุณาเข้าสู่ระบบเพื่อเข้าใช้งาน</span>
                                    <Button
                                        onClick={handleSubmitComplete}
                                        className="reset-password-submit-button"
                                    >
                                        เข้าสู่ระบบ
                                    </Button>
                                </div>
                            </> :
                            <div className="reset-password-right-content-control">
                                <img src={LOGO_MAIN} className="reset-password-right-logo"></img>

                                <form onSubmit={handleSubmit} className="reset-password-right-form-control">
                                    <div className="reset-form-item-control">
                                        <span className="reset-password-right-label mt-0">ตั้งค่ารหัสผ่านใหม่</span>
                                        <input
                                            className="reset-password-form-input"
                                            type="password"
                                            id="password"
                                            placeholder="รหัสผ่าน"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
                                        />
                                        {errors.password && <p style={{ color: "red", fontSize: "14px" }}>{errors.password}</p>}
                                    </div>
                                    <div>
                                        <input
                                            className="reset-password-form-input"
                                            type="password"
                                            id="password"
                                            placeholder="ยืนยันรหัสผ่าน"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
                                        />
                                        {errors.confirmPassword && <p style={{ color: "red", fontSize: "14px" }}>{errors.confirmPassword}</p>}
                                    </div>

                                    <Button
                                        className="reset-password-submit-button"
                                        onClick={handleSubmit}
                                    >
                                        ตั้งค่ารหัสผ่านใหม่
                                    </Button>
                                </form>

                            </div>
                    }

                    {
                        isResendShow && <ResendLinkModal show={isResendShow} onClose={handleCloseResendShow} onSubmit={onSubmitResendLink}></ResendLinkModal>
                    }


                </div>
            </div>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )

}

export default ResetPasswordComponent;